export enum BillingItemsQuickFilters {
  Chargeable = 'chargeable',
  All = 'all',
}
